import React from 'react'

import AirshipChakraProvider from '@ua/design-system/AirshipChakraProvider'

interface Props {
  children: React.ReactNode
}

const AirshipProvider: React.FC<React.PropsWithChildren<Props>> = ({
  children,
}) => {
  return <AirshipChakraProvider>{children}</AirshipChakraProvider>
}

export default AirshipProvider
